export const BREAKPOINTS = {
    "SM": 576,
    "MD": 768,
    "LG": 992,
    "XL": 1200,
    "XXL": 1400,
}

export const numberToEuro = function(num) {
    return num.toString().replace(/\B(?=(\d{3})+(?!\d))/g, '.')
}

export const translateCurrency = function(from, to, currency){
    let fromRate = obj.rates[from] || 1;
    let toRate = obj.rates[to] || 1;
    if(fromRate > toRate){
        fromRate = fromRate / fromRate;
        toRate = toRate / fromRate;
    }
    console.log("RATES:", fromRate, toRate);
    return toRate * currency;
}

export const CURRENCY_TYPE = {
    USD: "USD",
    EUR: "EUR",
    NOK: "NOK"
}

let obj = {
    "rates": {
        "EUR": 0.90,
        "NOK": 8.89,
    }
}

export const toTitleCase = function(str) {
    return str.replace(
        /\w\S*/g,
        function(txt) {
        return txt.charAt(0).toUpperCase() + txt.substr(1).toLowerCase();
        }
    );
}